<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    class="flex flex-1 flex-col-reverse lg:flex-row items-start bg-white no-copy"
  >
    <Sidebar
      class="hidden md:block"
      :exclude="['tools-nav']"
      @color-update="handleColorUpdate"
      @design-upload="handleFileUpload"
    />
    <div class="w-full flex flex-col flex-1 min-w-0">
      <div class="hidden md:block">
        <Navbar />
        <!-- <Promobar v-else /> -->
      </div>
      <div class="w-full md:border-r bg-white">
        <div v-if="isSubscriberLoaded && !isSubscriber" class="flex w-full">
          <Adsense
            v-if="isMobile"
            root-class="w-full"
            style="display: block"
            data-ad-client="ca-pub-4986239316862628"
            data-ad-slot="4734379636"
            data-ad-format="auto"
            data-full-width-responsive="true"
          ></Adsense>
          <!-- <Adsense
          v-else
          root-class="w-full"
          style="display: block"
          data-ad-client="ca-pub-4986239316862628"
          data-ad-slot="4734379636"
          data-ad-format="horizontal"
          data-full-width-responsive="true"
        >
        </Adsense> -->
        </div>
        <div class="lg:!max-w-full">
          <div
            class="pt-3 border-b relative"
            :class="{ 'background-primaryLight': isMobile }"
          >
            <div
              class="px-4 pt-4 pb-3 flex items-center justify-between md:hidden"
            >
              <div class="p-1" @click="handleBackClick">
                <Icon height="24" icon="solar:arrow-left-linear" />
              </div>
              <div
                class="flex gap-x-3 items-center"
                @click="handleNavigationDrawerClick"
              >
                <span
                  class="text-2xl text-text-content font-extrabold capitalize"
                >
                  {{
                    getPageTitle?.length > 18
                      ? getPageTitle?.slice(0, 18 - 1) + "..."
                      : getPageTitle
                  }}
                </span>
                <Icon height="16" icon="ri:arrow-down-s-line" />
              </div>
              <RouterLink to="/search" class="p-2 block">
                <Icon height="20" icon="solar:magnifer-linear" />
              </RouterLink>
            </div>
            <div class="pl-1 md:px-4 gap-4 flex-col items-start flex">
              <div class="hidden md:flex gap-x-3 items-center">
                <Button
                  v-if="route.name == 'mockup-tag-list' && showNavBackBtn"
                  class="p-2"
                  variant="outline"
                  @click="handleBackClick"
                >
                  <Icon icon="solar:alt-arrow-left-linear"></Icon>
                </Button>
                <Breadcrumb>
                  <BreadcrumbList>
                    <BreadcrumbItem
                      v-for="(link, index) in breadcrumbsList"
                      :key="index"
                      class="capitalize"
                    >
                      <router-link
                        :to="link"
                        :class="{
                          'text-text-content':
                            index == breadcrumbsList.length - 1,
                        }"
                      >
                        {{ $t(getBreadcrumbName(link)) }}
                      </router-link>
                      <span v-if="index < breadcrumbsList.length - 1">/</span>
                    </BreadcrumbItem>
                  </BreadcrumbList>
                </Breadcrumb>
              </div>
              <div
                class="hidden md:flex justify-between flex-col sm:flex-row gap-3 w-full"
              >
                <div>
                  <h1
                    class="text-lg md:text-4xl font-bold text-left font-Bricolage"
                    v-html="metaData?.header?.h1"
                  ></h1>
                  <h2
                    class="text-sm mt-2 text-text-secondary text-left"
                    v-html="metaData?.header?.description"
                  ></h2>
                </div>
              </div>
            </div>
            <div
              v-if="
                route.params.subcategory ||
                route.name == 'mockup-tag-list' ||
                route.name == 'mockups'
              "
              class="flex gap-x-2 w-full items-center mt-4 pl-2 sm:px-4"
            >
              <template v-if="tagList?.length">
                <div
                  class="py-1 px-3 rounded-3xl bg-background-secondary w-max align-middle h-full md:hidden"
                  @click="handleFilterDrawerClick"
                >
                  <Icon height="20" icon="basil:settings-adjust-outline" />
                </div>
                <div class="w-full flex gap-x-2 items-center min-w-0">
                  <TagsSlider
                    :tag-list="tagList"
                    :slides-per-group="isMobile ? 1 : 5"
                    :auto-slide="isMobile"
                    class="min-w-0"
                    @featured-click="handleFeaturedClick"
                  >
                    <template
                      v-if="route.name == 'subcategory'"
                      #before
                    ></template>
                    <template #default="{ item, index, currentSlide }">
                      <RouterLink
                        v-if="route.name == 'mockups'"
                        :to="item?.link"
                        class="pl-1.5 pr-3 py-1 flex items-center gap-x-1 rounded-full text-sm font-medium border capitalize cursor-pointer transition-all ease-linear"
                        :class="
                          currentSlide == index && isMobile
                            ? 'bg-[#FCEEF4] text-primary border-transparent'
                            : 'bg-background-secondary hover:bg-[#FCEEF4] border-border-primary hover:border-[#FCEEF4] text-text-content hover:text-primary'
                        "
                        @click="
                          handleTagClick(currentSlide == index && isMobile)
                        "
                      >
                        <AdvanceImage
                          v-if="item?.img"
                          :src="item?.img"
                          alt="tag thumbnail"
                          class="w-6 h-6 rounded-full overflow-hidden"
                          img-class="w-full h-full object-cover"
                          container-class="w-full h-full"
                        />
                        <div class="flex items-center gap-x-1">
                          <span>{{ item.label }}</span>
                          <Icon
                            v-if="currentSlide == index"
                            height="20"
                            icon="ri:close-line"
                          />
                        </div>
                      </RouterLink>
                      <RouterLink
                        v-else
                        :to="{
                          name: 'mockup-tag-list',
                          params: {
                            tags:
                              tagDictionary?.[item.label] ??
                              `${replaceSpaces(item?.label)}-${
                                subcategoryFilter?.[0]
                              }`,
                          },
                          state: { slide: index },
                        }"
                        class="pl-1.5 pr-3 py-1 flex items-center gap-x-1 rounded-full text-sm font-medium border capitalize cursor-pointer transition-all ease-linear"
                        :class="
                          currentSlide == index && isMobile
                            ? 'bg-[#FCEEF4] text-primary border-transparent'
                            : 'bg-background-secondary hover:bg-[#FCEEF4] border-border-primary hover:border-[#FCEEF4] text-text-content hover:text-primary'
                        "
                        @click="
                          handleTagClick(currentSlide == index && isMobile)
                        "
                      >
                        <AdvanceImage
                          v-if="item?.['thumbnail']"
                          :src="item?.['thumbnail']"
                          alt="tag thumbnail"
                          class="w-6 h-6 rounded-full overflow-hidden"
                          img-class="w-full h-full object-cover"
                          container-class="w-full h-full"
                        />
                        <div class="flex items-center gap-x-1">
                          <span>{{ item.label }}</span>
                          <Icon
                            v-if="currentSlide == index"
                            height="20"
                            icon="ri:close-line"
                          />
                        </div>
                      </RouterLink>
                    </template>
                  </TagsSlider>
                  <div class="w-max hidden md:block">
                    <Select v-model="sortBy">
                      <SelectTrigger
                        class="capitalize text-text-content font-medium text-sm gap-x-2 border-none"
                      >
                        <span class="w-4">
                          <Icon
                            icon="solar:sort-linear"
                            class="text-text-secondary"
                            height="16"
                            width="16"
                          />
                        </span>
                        <span>{{ $t(sortBy, sortBy) }}</span>
                      </SelectTrigger>
                      <SelectContent>
                        <SelectGroup>
                          <SelectItem
                            v-for="(option, id) in sortOptions"
                            :key="id"
                            :value="option?.value"
                            class="cursor-pointer"
                          >
                            {{ $t(option?.value, option?.value) }}
                          </SelectItem>
                        </SelectGroup>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
              </template>
              <template v-else>
                <Skeleton component="tagslider"></Skeleton>
              </template>
            </div>
            <div class="mx-auto px-2">
              <SSGMockupGrid
                v-if="
                  route.name !== 'mockup-tag-list' &&
                  (isSSG || !route.query.page || route.query.page <= 1)
                "
                :mockups="currentMockups"
                :color="color"
                :design="design"
              />
              <MockupGrid
                v-else
                :color="color"
                :design="design"
                :mockups="currentMockups"
                @loaded="onLoaded"
                @show-more-mockups="(val) => (showMoreMockups = val)"
              >
                <div
                  v-if="
                    moreMockups?.length &&
                    showMoreMockups &&
                    route.name == 'mockup-tag-list'
                  "
                  class="mt-12"
                >
                  <div
                    class="mb-5 text-sm text-text-secondary flex gap-x-3 items-center w-full justify-center"
                  >
                    <span class="w-6 border-t border-[#5D6676]"></span>
                    {{ $t("listing.moreMockups", "More Mockups") }}
                    <span class="w-6 border-t border-[#5D6676]"></span>
                  </div>
                  <MockupGrid
                    :color="color"
                    :design="design"
                    :mockups="moreMockups"
                    :hide-pagination="false"
                  />
                </div>
                <div
                  v-if="isMobile"
                  class="sticky bottom-20 right-4 z-20 bg-background-highlight rounded-full p-3 w-max ml-auto cursor-pointer ai-preview-shadow"
                  @click="handlePreviewClick"
                >
                  <Icon color="white" icon="mingcute:ai-line" height="24" />
                </div>
              </MockupGrid>
            </div>
            <div
              class="sticky right-2 md:right-10 bottom-[130px] md:bottom-10 z-40 hidden sm:flex justify-end w-min ml-auto mb-2"
            >
              <TallyFeedbackForm />
            </div>
          </div>
          <FooterInfo :meta-data="metaData">
            <template #faq-title>
              <h2 class="text-2xl font-bold text-text-content flex gap-x-1">
                FAQs {{ $t("on", "on") }}
                <span
                  v-if="
                    route.name != 'mockup-tag-list' &&
                    (route?.params?.subcategory || route?.params?.category)
                  "
                  class="capitalize"
                >
                  {{
                    route?.params?.subcategory
                      ? $t(route?.params?.subcategory)
                      : $t(route.params.category)
                  }}
                </span>
                <span
                  v-if="route.name == 'mockup-tag-list' && tag"
                  class="capitalize"
                >
                  {{ tag == "3d" ? tag.toUpperCase() : capitalize(tag) }}
                </span>
                <span
                  v-if="
                    !tagDictionary[tag] &&
                    tagsSubcategory &&
                    (tagsSubcategory != 'iphone' || tagsSubcategory != 'laptop')
                  "
                  class="capitalize"
                >
                  {{ $t(tagsSubcategory) }}
                </span>
                <span class="capitalize">{{ $t("mockups", "Mockups") }}</span>
              </h2>
            </template>
          </FooterInfo>
        </div>
      </div>
    </div>
  </div>
  <!-- Footer  -->
  <Footer />
  <Teleport to="head">
    <component :is="'script'" type="application/ld+json">
      { "@context": "https://schema.org/", "@type": "Product", "name": "{{
        metaData?.meta?.title
      }}", "description": "{{ metaData?.meta?.description }}", "review": {
      "@type": "Review", "reviewRating": { "@type": "Rating", "ratingValue":
      "4", "bestRating": "5" }, "author": { "@type": "Person", "name": "Sarfaraj
      ansari" } }, "aggregateRating": { "@type": "AggregateRating",
      "ratingValue": "4.4", "reviewCount": "191" } }
    </component>
    <component :is="'script'" type="application/ld+json">
      {{ faqJsonLd }}
    </component>
  </Teleport>
  <ClientOnly>
    <NavigationDrawer />
    <FilterDrawer />
    <PreviewDrawer
      @upload="handleFileUpload"
      @color-update="handleColorUpdate"
    />
  </ClientOnly>
  <NavBottomBar v-if="isMobile" />
</template>

<script setup>
import { computed, ref, reactive, watch, onBeforeMount, onMounted } from "vue";
import MockupGrid from "@/components/listing/MockupGrid.vue";
import {
  getImageUrlFromLocalStorage,
  extractTagFromRoute,
  getBreadcrumbName,
  generateBreadcrumbs,
  extractSubCategoryFromRoute,
  findCategoryFromSubCat,
  colorExtractor,
  generateDynamicTemplate,
  shuffleArray,
  tagDictionary,
  replaceSpaces,
  capitalize,
  getFilteredData,
  formatName,
  getOrganizedMockups,
  categoriesList,
} from "@/util/common.util";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
} from "@/components/ui/breadcrumb";
import placeHolderImage from "@/assets/designPlaceholder.png";
import Navbar from "@/components/navbar/index.vue";
import Footer from "@/components/common/Footer.vue";
import subCategoryData from "@/data/subcategoryData.json";
import { useHead } from "@vueuse/head";
import { Icon } from "@iconify/vue";
import Fuse from "fuse.js";
import { Button } from "@/components/ui/button";
import Skeleton from "@/components/skeleton/skeleton.vue";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import {
  resetPagination,
  openNavigationDrawer,
  openFilterDrawer,
  openPreviewDrawer,
} from "@/lib/utils.js";
// import Promobar from "@/components/common/Promobar.vue";
import { useMetaDataStore } from "@/datastore/module/metaData.js";
import { useMockupStore } from "@/datastore/module/mockup.js";
import { useRoute, useRouter, RouterLink } from "vue-router";
import TagsSlider from "@/components/listing/TagsSlider.vue";
import NavigationDrawer from "@/components/listing/NavigationDrawer.vue";
import FilterDrawer from "@/components/listing/FilterDrawer.vue";
import PreviewDrawer from "@/components/listing/PreviewDrawer.vue";
import NavBottomBar from "@/components/navbar/BottomBar.vue";
import Sidebar from "@/components/sidebar/index.vue";
import TallyFeedbackForm from "@/components/listing/TallyFeedbackForm.vue";
import AdvanceImage from "@/components/common/AdvanceImage.vue";
import tagData from "@/data/dynamic_tags.json";
import FooterInfo from "@/components/common/FooterInfo.vue";
import { categories } from "@/views/landing/misc/dataProvider.js";
import { useMediaQuery } from "@vueuse/core";
import SSGMockupGrid from "@/components/listing/SSGMockupGrid.vue";
import { useVideoMockupsStore } from "@/datastore/module/videoMockup.js";

const dataStore = useMetaDataStore();
const store = useMockupStore();
const route = useRoute();
const router = useRouter();
const storeVideo = useVideoMockupsStore();

const isSSG = import.meta.env.SSR;

const design = ref(null);
const fuseOptions = reactive({
  threshold: 0.2,
  keys: ["meta.tags"],
});
const fuseData = ref(null);
const filteredMockups = ref([]);
const showNavBackBtn = ref(true);
const loading = ref(true);
const showMoreMockups = ref(false);
const tagsSubCategoryValue = ref("");
const tagValue = ref("");
const sortBy = ref(route?.query?.sort || "new");
const sortOptions = reactive([
  { name: "Random", value: "random" },
  { name: "New", value: "new" },
]);
const tagsPageData = ref([]);
const subcategoryConfig = ref("");
const organizedMockups = ref();

const isMobile = useMediaQuery("(max-width: 767px)");

const metaDataStore = computed(() => dataStore.getMetaData);
const filteredData = computed(() => store["filteredData"]);
const categorizedData = computed(() => store["categorizedData"]);
const subcategoryFilter = computed(() => store["subcategoryFilter"]);
const categoryFilter = computed(() => store["categoryFilter"]);
const color = computed(() => store["color"]);
const isSubscriberLoaded = computed(() => store["isSubscriberLoaded"]);
const isSubscriber = computed(() => store["isSubscriber"]);
const tagsSubcategory = computed(() => tagsSubCategoryValue.value);
const tag = computed(() => tagValue.value);
const currentMockups = computed(() => filteredMockups.value);
const featuredMockups = computed(() => store.featuredMockups);

const breadcrumbsList = computed(() => {
  if (route.name === "mockup-tag-list") {
    const category = findCategoryFromSubCat(
      categoriesList,
      tagsSubcategory.value,
    );
    const routeName = `mockups/${category}/${tagsSubcategory.value}/${tag.value}`;
    return generateBreadcrumbs(routeName);
  } else {
    const routeName = route.path;
    return generateBreadcrumbs(routeName);
  }
});

const moreMockups = computed(() => {
  if (route.name !== "mockup-tag-list") return;
  const data = filteredData.value?.slice(0, 10);
  return data;
});

const faqJsonLd = computed(() => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: metaData.value?.footer?.faq?.map((faq) => ({
      "@type": "Question",
      name: faq?.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq?.answer,
      },
    })),
  };
  return JSON.stringify(faqSchema);
});

const collectionPageObject = computed(() => ({
  "@type": "CollectionPage",
  "@id": `https://mockey.ai${route.fullPath}`,
  url: `https://mockey.ai${route.fullPath}`,
  name: metaData.value.meta?.title,
  description: metaData.value.meta?.description,
  thumbnailUrl:
    filteredData.value?.[0]?.mockup?.["preview-thumbnail"] ||
    filteredData.value?.[0]?.mockup?.["thumbnail"],
  isPartOf: { "@id": "https://mockey.ai/#website" },
  primaryImageOfPage: {
    "@id": `https://mockey.ai${route.fullPath}/#primaryimage`,
  },
  image: { "@id": `https://mockey.ai${route.fullPath}/#primaryimage` },
  breadcrumb: { "@id": `https://mockey.ai${route.fullPath}/#breadcrumb` },
  inLanguage: "en-US",
}));

const imageObject = computed(() => ({
  "@type": "ImageObject",
  inLanguage: "en-US",
  "@id": `https://mockey.ai${route.fullPath}/#primaryimage`,
  url:
    filteredData.value?.[0]?.mockup?.["preview-thumbnail"] ||
    filteredData.value?.[0]?.mockup?.["thumbnail"],
  contentUrl:
    filteredData.value?.[0]?.mockup?.["preview-thumbnail"] ||
    filteredData.value?.[0]?.mockup?.["thumbnail"],
  width: filteredData.value?.[0]?.mockup.size.width,
  height: filteredData.value?.[0]?.mockup.size.height,
  caption: formatName(filteredData.value?.[0]?.name),
}));

const breadcrumbs = computed(() => {
  return breadcrumbsList.value?.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    item: {
      "@id": `https://mockey.ai${
        breadcrumbsList.value?.length > 3 ? route?.path : item
      }`,
      name: item?.split("/")?.filter(Boolean)?.pop(),
    },
  }));
});

const breadcrumbObject = computed(() => ({
  "@id": "https://mockey.ai/#breadcrumb",
  "@type": "BreadcrumbList",
  itemListElement: breadcrumbs.value,
}));

const metaData = computed(() => {
  const { category, subcategory } = route.params;
  if (category && subcategory) {
    return (
      metaDataStore.value?.[subcategory] ||
      metaDataStore.value?.[category] ||
      null
    );
  } else if (category) {
    return metaDataStore.value?.[category];
  } else if (route.name === "mockup-tag-list") {
    const subcat = tagsSubcategory.value;
    if (metaDataStore.value?.[replaceSpaces(`${tag.value}-${subcat}-tag`)]) {
      return metaDataStore.value?.[replaceSpaces(`${tag.value}-${subcat}-tag`)];
    }
    return generateDynamicTemplate(
      metaDataStore.value?.[`${subcat}-tag`],
      tag.value,
      `${subcat}-tag`,
    );
  } else {
    return metaDataStore.value?.["mockups"];
  }
});

watch(
  () => route.params.category,
  (newValue) => {
    store.updateCategoryFilter(newValue);
  },
  { immediate: true },
);

watch(
  () => route.params.subcategory,
  (newValue) => {
    store.updateSubcategoryFilter(newValue);
  },
  { immediate: true },
);

watch(sortBy, (newVal) => {
  resetPagination.next();
  let currentQuery = { ...route.query };
  if (newVal === "random") {
    currentQuery.sort = "random";
    delete currentQuery.page;
    router.replace({ query: { ...currentQuery } });
    if (route.name === "mockup-tag-list") {
      filteredMockups.value = shuffleArray([...tagsPageData.value]);
    } else {
      filteredMockups.value = shuffleArray([...filteredData.value]);
    }
  } else {
    delete currentQuery.sort;
    delete currentQuery.page;
    router.replace({ query: { ...currentQuery } });
    if (route.name === "mockup-tag-list") {
      filteredMockups.value = tagsPageData.value;
    } else {
      filteredMockups.value = filteredData.value;
    }
  }
});

watch(
  () => route.params.tags,
  async () => {
    if (route.name === "mockup-tag-list") {
      const extactedColor = colorExtractor(route.params.tags);
      if (extactedColor) store.updateColor(extactedColor);
      else store.updateColor({ hex: "#f2f2f2" });
      tagsSubCategoryValue.value = extractSubCategoryFromRoute(
        route.params.tags,
      );
      const category = findCategoryFromSubCat(
        categoriesList,
        tagsSubCategoryValue.value,
      );
      if (tagsSubCategoryValue.value && category) {
        store.updateCategoryFilter(category);
        store.updateSubcategoryFilter(tagsSubCategoryValue.value);
        storeVideo.updateCategoryFilter(category);
        storeVideo.updateSubcategoryFilter(tagsSubCategoryValue.value);
      }
      fuseData.value = new Fuse(filteredData.value, fuseOptions);
      tagValue.value = extractTagFromRoute(route.params.tags);
      const data = fuseData.value.search(tagValue.value);
      if (data?.length) {
        filteredMockups.value = data.map((res) => res.item);
        tagsPageData.value = filteredMockups.value;
      } else {
        filteredMockups.value = filteredData.value;
      }
    }
  },
  { immediate: true },
);

watch(
  [() => filteredData.value, () => route.query.filter, () => route.query.sort],
  ([filterData, filterVal, sortVal]) => {
    let currentData;

    if (filterData) {
      if (route.name === "mockup-tag-list") return;
      if (route.name === "mockups") {
        filteredMockups.value = organizedMockups.value;
      }
      currentData = filterData;
    }

    if (filterVal) {
      const data = getFilteredData(filteredData.value, filterVal);
      currentData = data;
      filteredMockups.value = data;
    }

    if (sortVal) {
      if (sortVal === "random") {
        filteredMockups.value = shuffleArray([...currentData]);
      }
      if (sortVal === "new") {
        filteredMockups.value = currentData;
      }
    }
  },
  { deep: true },
);

const headConfig = computed(() => {
  const md = metaData.value?.meta || {};
  const url = `https://mockey.ai${route.fullPath}`;

  // Basic & viewport
  const baseMeta = [
    { name: "description", content: md.description || "" },
    { charset: "utf-8" },
    { name: "viewport", content: "width=device-width, initial-scale=1" },
  ];

  // Open Graph
  const ogMeta = [
    { property: "og:title", content: md.title || "" },
    { property: "og:description", content: md.description || "" },
    { property: "og:url", content: url },
  ];

  // Twitter
  const twitterMeta = [
    { property: "twitter:title", content: md.title || "" },
    { property: "twitter:description", content: md.description || "" },
  ];

  // JSON-LD scripts
  const jsonLdScripts = [
    {
      type: "application/ld+json",
      id: "breadcrumb-schema",
      innerHTML: JSON.stringify(breadcrumbObject.value),
    },
    {
      type: "application/ld+json",
      id: "collection-schema",
      innerHTML: JSON.stringify(collectionPageObject.value),
    },
    {
      type: "application/ld+json",
      innerHTML: JSON.stringify(imageObject.value),
    },
  ];

  return {
    title: md.title || "Mockey.ai",
    meta: [...baseMeta, ...ogMeta, ...twitterMeta],
    link: [{ rel: "canonical", href: url }],
    script: jsonLdScripts,
  };
});

useHead(headConfig.value);

let { category, subcategory } = route.params;
let tagList = [];
if (category && subcategory) {
  tagList = tagData[subcategory];
} else if (category) {
  store.resetSubcategoryFilter();
  tagList = tagData[category];
} else if (route.name === "mockups") {
  store.resetSubcategoryFilter();
  tagList = categories;
} else if (route.name === "mockup-tag-list") {
  const tags = tagData[tagsSubCategoryValue.value];
  if (isMobile.value) {
    tagList = tags;
  } else {
    tagList = tags?.filter((item) => item.value !== tag.value);
  }
}

onBeforeMount(async () => {
  let { category, subcategory } = route.params;
  if (category) {
    store.resetSubcategoryFilter();
    store.updateCategoryFilter(category);
    storeVideo.updateCategoryFilter(category);
  }
  if (category && subcategory) {
    store.updateSubcategoryFilter(subcategory);
    storeVideo.updateSubcategoryFilter(subcategory);
    subcategoryConfig.value = subcategory && subCategoryData[subcategory];
  }
  if (route.name === "mockups") {
    organizedMockups.value = getOrganizedMockups(categorizedData.value);
  }
});

onMounted(async () => {
  // Check if there is a history back state
  showNavBackBtn.value = !!window.history.state.back;

  window.scrollTo(0, 0);

  let persist = route.query.persist;
  let designUrl = await getImageUrlFromLocalStorage(
    "design-file",
    "",
    persist ? true : false,
  );
  if (designUrl) {
    design.value = designUrl;
  } else {
    let { subcategory } = route.params;
    if (
      subcategory &&
      subCategoryData[subcategory] &&
      subCategoryData[subcategory].placeholder
    ) {
      design.value = subCategoryData[subcategory].placeholder;
    } else {
      design.value = placeHolderImage;
    }
  }
  // eslint-disable-next-line no-undef
  Tally.loadEmbeds();
});

const handleTagClick = (state) => {
  if (
    categoryFilter.value?.length &&
    subcategoryFilter.value?.length &&
    route.name === "mockup-tag-list" &&
    state
  ) {
    router.push({
      name: "subcategory",
      params: {
        category: categoryFilter.value[0],
        subcategory: subcategoryFilter.value[0],
      },
      state: null,
    });
  }
};

const handleNavigationDrawerClick = () => {
  openNavigationDrawer.next();
};

const handlePreviewClick = () => {
  openPreviewDrawer.next();
};

const handleFilterDrawerClick = () => {
  openFilterDrawer.next();
};

const handleBackClick = () => {
  router.back();
};

const handleFileUpload = (file) => {
  design.value = file;
};

const handleColorUpdate = (color) => {
  store.updateColor(color);
};

const onLoaded = () => {
  loading.value = false;
};

const handleFeaturedClick = () => {
  filteredMockups.value = featuredMockups.value[route.params.subcategory];
};

const getPageTitle = computed(() => {
  const { category, subcategory, tags } = route.params;
  if (!category && !subcategory && !tags) return "All-Mockups";
  else if (category && subcategory) return subcategory;
  else if (category) return category;
  else if (tags) return capitalize(tags);
  else return "All-Mockups";
});
</script>
<style lang="css" scoped src="./style.css"></style>
